module.exports = __webpack_public_path__ + "img/unifacs-branco.d4d9c6fa.svg";